<template>
  <Box size="small" variant="alt-light" class="contact box--bordered">
    <Media align="middle">
      <MediaBody class="contact__body">
        <div>
          <Icon id="external" class="mrgr-" />
          {{ contact.first_name }} {{ contact.last_name }}
          <span v-if="contact.company">({{ contact.company }})</span>
        </div>

        {{ contact.username }}
      </MediaBody>

      <MediaRight>
        <ListInline size="small" class="justify-content-end">
          <li class="contact__action">
            <Btn
              data-cy="edit-button"
              variant="link"
              class="pdgh0"
              @click="toggleAddOrUpdate()"
            >
              <Icon id="edit" :scale="0.6" />
              {{ $t('common.edit') }}
            </Btn>
          </li>

          <li class="contact__action">
            <Btn
              data-cy="delete-button"
              variant="link"
              class="pdgh0"
              @click="toggleDelete()"
            >
              <Icon id="trash" :scale="0.6" />
              {{ $t('common.delete') }}
            </Btn>
          </li>
        </ListInline>
      </MediaRight>
    </Media>
  </Box>
</template>

<script>
import eventBus from '@/eventBus';

import Icon from '@/components/ui/Icon.vue';

export default {
  components: {
    Icon,
  },

  props: {
    contact: {
      type: Object,
      required: true,
    },
  },

  methods: {
    toggleContactForm() {
      eventBus.$emit('toggleContactForm', this.contact);
    },

    toggleAddOrUpdate() {
      eventBus.$emit('toggleContactAddOrUpdateDialog', this.contact);
    },

    toggleDelete() {
      eventBus.$emit('toggleContactDeleteDialog', this.contact);
    },
  },
};
</script>

<style lang="scss" scoped>
.contact {
  &:hover,
  &:focus-within {
    .contact__action {
      opacity: 1;
    }
  }
}
.contact__body {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.contact__action {
  font-size: rem(13px);

  opacity: 0;
  transition: opacity 0.15s ease-in;
}
</style>
